import React, { useState, useEffect } from 'react';

const AnnouncementsSettings = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [isShortcodeCopied, setIsShortcodeCopied] = useState(false);

  useEffect(() => {
    fetch('/wp-json/wp/v2/announcement')
      .then(response => response.json())
      .then(data => setAnnouncements(data))
      .catch(error => console.error('Error fetching announcements:', error));
  }, []);

  const copyToClipboard = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    console.log("Text copied to clipboard:", text);
    setIsShortcodeCopied(true); // Set the state to indicate that the shortcode is copied
  };

  const handlePostSelection = (post) => {
    setSelectedPost(post);
    setIsShortcodeCopied(false); // Reset the state when a new post is selected
  };

  const handleInsertShortcode = () => {
    if (selectedPost) {
      const shortcode = `[te_featured_announcement post_id=${selectedPost.id}]`;
      copyToClipboard(shortcode);
      // Verwijzing toevoegen naar de gewenste URL
      window.location.href = 'https://nick-blok.com/wp-admin/post.php?post=10&action=edit';
    }
  };
  
  return (
    <div>
      <div className="banner-settings-wrapper">
        <h1>Announcement instellingen</h1>
        <div className="banner-settings-switch">
          <div className="banner-settings-inner-content">
            <div className="banner-settings-inner-content-details_input">
              <h5>Selecteer aankondiging</h5>
              <p>Selecteer hier de aankondiging waar je een shortcode van wil genereren.</p>
              <ul className="post-types-list">
                {/* Toon hier de lijst van opgehaalde aankondigingen */}
                {announcements.map(announcement => (
                  <li className="post-types-list-item" key={announcement.id} onClick={() => handlePostSelection(announcement)}>
                    {announcement.title.rendered}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="banner-settings-wrapper">
        <div className="banner-settings-switch">
          <div className="shortcode-wrapper">
            <h2>Shortcode van geselecteerde post</h2>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {selectedPost && (
                <li className="post-list-item" onClick={() => copyToClipboard(`[te_featured_announcement post_id=${selectedPost.id}]`)}>
                  [te_featured_announcement post_id={selectedPost.id}]
                </li>
              )}
            </ul>
            {/* Conditionally render the button only if the shortcode is copied */}
            {isShortcodeCopied && (
              <a href="https://nick-blok.com/wp-admin/post.php?post=10&action=edit" rel="noopener noreferrer">
                <button className="save-button" style={{ marginTop: '10px' }} onClick={handleInsertShortcode}>Voeg shortcode in op pagina</button>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementsSettings;
